export default (phoneNumber) => `254${phoneNumber.substr(-9)}`;
